import mediumEmphasis from '../../text/medium-emphasis';

const primary = (params) => mediumEmphasis(params);

export default primary;
